
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon24CellularBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(4)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.638 0c1.791 0 3.261 1.328 3.357 3l.005.175v17.65c0 1.696-1.41 3.08-3.178 3.17l-.184.005H3.362C1.57 24 .1 22.672.005 21L0 20.825V3.175C0 1.479 1.41.095 3.178.005L3.362 0h9.276zm1.572 19.543H1.789v1.285c0 .765.628 1.398 1.43 1.466l.143.006h9.276c.821 0 1.494-.591 1.566-1.338l.007-.134-.001-1.285zm-1.572-17.84H3.362c-.822 0-1.494.59-1.566 1.338l-.007.134v14.664H14.21V3.175c0-.765-.627-1.398-1.429-1.466l-.143-.006z",
  fill: "#000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "var(--theme-primary, #810ea9)",
  x: 5,
  y: 3,
  width: 6,
  height: 1.632,
  rx: 0.816
}))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g transform=\"translate(4)\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M12.638 0c1.791 0 3.261 1.328 3.357 3l.005.175v17.65c0 1.696-1.41 3.08-3.178 3.17l-.184.005H3.362C1.57 24 .1 22.672.005 21L0 20.825V3.175C0 1.479 1.41.095 3.178.005L3.362 0h9.276zm1.572 19.543H1.789v1.285c0 .765.628 1.398 1.43 1.466l.143.006h9.276c.821 0 1.494-.591 1.566-1.338l.007-.134-.001-1.285zm-1.572-17.84H3.362c-.822 0-1.494.59-1.566 1.338l-.007.134v14.664H14.21V3.175c0-.765-.627-1.398-1.429-1.466l-.143-.006z\" fill=\"#000\" fill-rule=\"nonzero\"/>\r\n        <rect fill=\"var(--theme-primary, #810ea9)\" x=\"5\" y=\"3\" width=\"6\" height=\"1.632\" rx=\".816\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-24-cellular-black.5a0823a5855c6084c523fc7d19bc69a9.svg"),
        {
          React: SvgIcon24CellularBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      